import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const DndBoardWidget: WidgetRegistryEntry = {
  name: "DndBoard",
  configuration: async () => (await import("./configuration")).DndBoardWidgetConfiguration,
  component: async () => (await import("./dnd-board-widget.component")).DNDBoardWidgetComponent
};
